import { render, staticRenderFns } from "./ListCompanyUnits.vue?vue&type=template&id=fa340068&"
import script from "./ListCompanyUnits.vue?vue&type=script&lang=js&"
export * from "./ListCompanyUnits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa340068')) {
      api.createRecord('fa340068', component.options)
    } else {
      api.reload('fa340068', component.options)
    }
    module.hot.accept("./ListCompanyUnits.vue?vue&type=template&id=fa340068&", function () {
      api.rerender('fa340068', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/lists/components/ListCompanyUnits.vue"
export default component.exports